export const MENU_WIDTH = 140;

export const TRIAL_UPLOAD_LIMIT = 3;
